import React from 'react';
import { TextDisplayContainer } from './TextDisplayContainer';

export const TxtViewer = ({
    text,
    fontSize,
    setFontSize,
    lineHeight,
    setLineHeight,
}) => {
    return (
        <TextDisplayContainer
            fontSize={fontSize}
            setFontSize={setFontSize}
            lineHeight={lineHeight}
            setLineHeight={setLineHeight}
            displayFontSettings={true}
        >
            {text}
        </TextDisplayContainer>
    );
};